// extracted by mini-css-extract-plugin
export default {"logo":"PrivateRoute_logo__JomY-","site-layout-content":"PrivateRoute_site-layout-content__dekdO"};